export const extractDisplayConditions = (beeJson: any): number[] => {
    const conditionIds = new Set<number>();

    // Check if beeJson has the expected structure
    if (!beeJson || !beeJson.page?.rows) {
        return Array.from(conditionIds);
    }

    // Iterate through all rows to find containers with display conditions
    const rows = beeJson.page.rows;
    for (const row of rows) {
        if (row.container?.displayCondition) {
            const condition = row.container.displayCondition;

            // Check if the condition has an ID (regardless of type)
            if (condition.id && typeof condition.id === 'number') {
                // Use Set to automatically handle duplicates
                conditionIds.add(condition.id);
            }
        }
    }

    // Convert Set back to array and return
    return Array.from(conditionIds);
};

/**
 * Extract display condition IDs from HTML content
 * Looks for {% if condition %} ... {% endif %} template blocks in the HTML
 */
export const extractDisplayConditionsFromHtml = (htmlContent: string): string[] => {
    // Regex to match {% if condition %} ... {% endif %} blocks
    // Using [\s\S] instead of . with 's' flag for better compatibility
    const conditionalRegex = /{%\s*if\s+(\w+)\s*%}([\s\S]*?){%\s*endif\s*%}/g;
    const matches = [];
    let match;

    // Extract all condition names from the template blocks
    while ((match = conditionalRegex.exec(htmlContent)) !== null) {
        const conditionKey = match[1]; // The condition name/key
        matches.push(conditionKey);
    }

    return Array.from(new Set(matches)); // Remove duplicates
};
